import * as React from "react";
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useLanguage } from "./Language";

export interface StudentOrGuardianDialogProps {
  open: boolean;
  onClickGuardianLogin?: () => void;
  onClickStudentLogin: () => void;
}

export const StudentOrGuardianDialog: React.FC<StudentOrGuardianDialogProps> = (
  props,
) => {
  const { onClickGuardianLogin, onClickStudentLogin, open } = props;
  const { translate } = useLanguage();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Dialog open={open} fullScreen={fullScreen}>
      <DialogTitle sx={{ textAlign: "center" }}>
        {translate("selectLogin")}
      </DialogTitle>
      <DialogContent>
        <Stack
          sx={{
            gap: 2,
          }}
        >
          <Button variant="contained" autoFocus onClick={onClickStudentLogin}>
            {translate("studentLogin")}
          </Button>
          <Divider>
            <Typography variant="overline">{translate("or")}</Typography>
          </Divider>
          <Button variant="outlined" onClick={onClickGuardianLogin}>
            {translate("guardianLogin")}
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};
